import { PromotedBadge } from "@faire/deprecated-retailer-visitor-shared/features/ADS/PromotedBadge";
import { shouldShowPromotedBadge } from "@faire/deprecated-retailer-visitor-shared/features/ADS/util";
import { IProduct } from "@faire/web-api--source/indigofair/data/IProduct";

import { ProductLink } from "./ProductLink";

export const PromotedTextBadge = ({
  isPromoted,
  promotedBy,
}: {
  isPromoted: boolean | undefined;
  promotedBy: Array<keyof typeof IProduct.PromotedType> | undefined;
}) => {
  if (!isPromoted || !promotedBy) {
    return null;
  }
  const showPromotedBadge = shouldShowPromotedBadge(isPromoted, promotedBy);
  return showPromotedBadge ? (
    <ProductLink>
      <PromotedBadge noPadding />
    </ProductLink>
  ) : null;
};
